import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

// Respostas do cliente no quiz ("Quase lá! Só mais uns detalhes."), em formato de leitura rápida.
const ShippingDetails = ({ listOfExtraDetails, elevatorFloorNumber }) => {
  const ORDER_STATE = useSelector(state => state.order);
  const { t } = useTranslation();

  const answeredIds = (listOfExtraDetails || []).map(extraDetail =>
    typeof extraDetail === "string" ? extraDetail : extraDetail?._id
  );

  return (
    <div>
      <div className="label">{t("shippingDetails.title")}</div>
      {(ORDER_STATE.extraDetails || []).map(extraDetail => {
        const yes = answeredIds.includes(extraDetail._id);
        // "Objetos frágeis" e "item que não passa pelas portas" saíram do quiz (13 out 2026): só aparecem em pedidos antigos que responderam Sim
        if (["FragileObjects", "OversizeItem"].includes(extraDetail.short_name) && !yes) return null;
        return (
          <div
            key={extraDetail._id}
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "16px", padding: "8px 0", borderBottom: "1px solid #eee", maxWidth: "520px" }}
          >
            <div style={{ fontSize: "14px" }}>
              {extraDetail.name}
              {yes && extraDetail.short_name === "UseElevator" && elevatorFloorNumber ? (
                <div style={{ fontSize: "13px", color: "#555", marginTop: "2px" }}>
                  Andar: <strong>{elevatorFloorNumber}º</strong>
                </div>
              ) : null}
            </div>
            <span
              style={{
                padding: "3px 12px",
                borderRadius: "12px",
                fontSize: "13px",
                fontWeight: 700,
                whiteSpace: "nowrap",
                background: yes ? "#e8f5e9" : "#f2f2f2",
                color: yes ? "#2e7d32" : "#888"
              }}
            >
              {yes ? t("shippingDetails.yes") : t("shippingDetails.no")}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default ShippingDetails;
